import { createApi } from "@reduxjs/toolkit/query/react";
import { baseAppQuery } from "shared/api/baseQuery";
import { TemplateParameterInfo, TemplateParameter } from "features/template/types/template";
import { snackbarOnQueryStarted } from "middleware/snackbarOnQueryStarted";

const ENDPOINT = "/template-parameter";
const templateApi = createApi({
    reducerPath:"templateApi",
    baseQuery:baseAppQuery,
    tagTypes: ["templateParameter"],
    endpoints:(builder)=>({
        getTemplateParameterList: builder.query<TemplateParameterInfo[], string>({
            query:(organizationId)=> `${ENDPOINT}/list?organizationId=${organizationId}`,
            providesTags: ["templateParameter"],
        }),
        getTemplateParameterListForCurrent: builder.query<TemplateParameterInfo[], void>({
            query:()=>`${ENDPOINT}/list-for-current`,
            providesTags: ["templateParameter"],
        }),
        updateTemplateParameter:builder.mutation<TemplateParameterInfo[], TemplateParameter>({
            query:(data)=>({
                url: ENDPOINT,
                method: "PUT",
                body: data
            }),
            invalidatesTags: ["templateParameter"],
            onQueryStarted: snackbarOnQueryStarted({
              successMessage:"successFormAlert",
              errorMessage:"errorFormAlert",
            })
        })
     
    })
})

export const {
    useGetTemplateParameterListQuery,
    useGetTemplateParameterListForCurrentQuery,
    useUpdateTemplateParameterMutation,
} = templateApi;
export default templateApi;